var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShurikens2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 211,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.1 148.59s-15.329-4.576-28.126.856c-12.506 5.309-20.154 19.638-20.154 19.638l-57.432 95.97-.399-.13 39.098-101.967s6.958-14.336 2.218-25.504c-4.74-11.168-19.887-16.121-19.887-16.121L.91 78.624l.183-.377 108.93 25.353s15.33 4.576 28.127-.856c12.798-5.432 20.154-19.638 20.154-19.638l57.433-95.97.399.13-39.098 101.967s-6.958 14.336-2.218 25.504c4.74 11.168 19.887 16.121 19.887 16.121l100.325 43.085-108.931-25.353z",
    fill: "#F6F6F6",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShurikens2);
export default __webpack_public_path__ + "static/media/shurikens-2.dcabf8fa069d7f9ec539c7c32ab060ae.svg";
export { ForwardRef as ReactComponent };